import { cn } from "@/lib/utils";

interface LoadingSpinnerProps {
  message?: string;
  className?: string;
}

export function LoadingSpinner({ message = "Carregando...", className }: LoadingSpinnerProps) {
  return (
    <div className={cn("flex flex-col items-center justify-center py-12", className)}>
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#0586C7]"></div>
      {message && (
        <p className="mt-4 text-gray-600 text-lg">{message}</p>
      )}
    </div>
  );
}
